'use strict';

angular.module('preferencesController', [])

.controller('PreferencesController', ['appInfo', '$scope', '$rootScope', '$log', '$location', '$window','AgencyService', 'BuyerService', 'CommonService', 
    function (appInfo, $scope, $rootScope, $log, $location, $window, AgencyService, BuyerService, CommonService) {    
    
     $scope.activeAgency = $rootScope.currentUser.activeAgency;
     $scope.page = 'preferences';
     
     $scope.agencyAllSuburbs  = [];
     // $scope.selectedSuburbs = []; 
     
     $scope.preferences = {};
     $scope.oldPreferences = {};

     $scope.propertyTypes = [];

     var initPreferences = function() {
        return preferences = {
            priceFrom: "",
            priceTo: "",
            suburbs: [],
            bed: "0",
            bath: "0",
            parking: "0",
            pool: "",
            propertyTypes: []
         };
     }


     var usercode    = $rootScope.currentUser.authdata;
     var activeAgency = $rootScope.currentUser.activeAgency;
     $scope.apiPath = appInfo.endpoint+'prospect/alllocations.json';
     $scope.apiParam = { api_key: appInfo.pkey, usercode: usercode, orgId: activeAgency.id};
     $scope.apiSearchField = "searchString";
     $scope.searchTextMinLen = "3";
     $scope.selectedOptions = [];


   
    var init = function() {
        $scope.propertyTypes = BuyerService.getPropertyTypes();
        $scope.preferences = initPreferences();
        $rootScope.loading = true;

        BuyerService.getBuyerPropertyRequestPreferences()
        .then(function(data){
          loadPreferences();
        })
        .catch(function(err) {
            console.log(err);
        })
        .finally(function(data){
        });
        //load preferences from db
      
    }

    var loadPreferences = function() {
        if(!$rootScope.loading) {
            $rootScope.loading = true;
        }
        BuyerService.getPreferences()
        .then(function(data){
            if(data.length > 0) {
                $scope.preferences = data[0];
                var suburbs = JSON.parse($scope.preferences.suburbs);
                var propertyTypes = JSON.parse($scope.preferences.propertyTypes);
                $scope.preferences.suburbs = suburbs;
                // $scope.selectedSuburbs = suburbs;  
                $scope.preferences.propertyTypes = propertyTypes; 
            } else if($rootScope.buyerPropertyRequestPreferences) {
                $scope.preferences = $rootScope.buyerPropertyRequestPreferences;
            }
            angular.forEach($scope.preferences.propertyTypes, function(propertyTypeId){
                var index = CommonService.indexById($scope.propertyTypes, propertyTypeId);
                if (index>-1) {
                    $scope.propertyTypes[index].selected = true;
                } 
            });
        })
        .catch(function(err){
            console.log(err);
        })
        .finally(function(data){
          $scope.oldPreferences = {
            priceFrom: $scope.preferences.priceFrom,
            priceTo: $scope.preferences.priceTo,
            suburbs: $scope.preferences.suburbs,
            bed: $scope.preferences.bed,
            bath: $scope.preferences.bath,
            parking: $scope.preferences.parking,
            pool: $scope.preferences.pool,
            propertyTypes: $scope.preferences.propertyTypes
         };


          $rootScope.loading = false;
        });
    }

    $scope.savePreferences = function() {
      // var suburbs = [ $scope.selectedSuburbs ];

      if($("#ajaxMulitSelectSearchText").val() == ''){
        $scope.preferences.suburbs = [];
      }

      var selectedPropertyTypes = [];
      angular.forEach($scope.propertyTypes, function(propertyType){
        if(propertyType.selected){
            selectedPropertyTypes.push(propertyType.id);
        }
      });

      // $scope.preferences.suburbs = suburbs;
      $scope.preferences.propertyTypes = selectedPropertyTypes;  
      
      $rootScope.loading = true;
      BuyerService.savePreferences($scope.preferences)
      .then(function(data){
        return BuyerService.addPreferenceChangeNote($scope.preferences, $scope.oldPreferences);
      })
      .then(function(data) {
        $location.path('/prefered-properties');
      })
      .catch(function(err){
        console.log(err);
      })
      .finally(function(data){
        loadPreferences();
        // $rootScope.loading = false;
      })
    }

    init();

}]);